import type { PresetOption } from 'consts/dashboard';
import type { components } from 'types/schemas/api-schema';

export type { PresetOption };

type SavedLogView = components['schemas']['UserViewResponse'];

export const isViewValid = (
  viewName: string | null | undefined,
  savedViewsList: SavedLogView[] | undefined,
  presetOptions: PresetOption[] = [],
): boolean => {
  if (!viewName) {
    return false;
  }

  if (savedViewsList && savedViewsList.length > 0) {
    const existsInSavedViews = savedViewsList.some((view) => view.name === viewName);
    if (existsInSavedViews) {
      return true;
    }
  }

  if (presetOptions?.length > 0) {
    const existsInPresets = presetOptions.some((preset) => preset.value === viewName);
    if (existsInPresets) {
      return true;
    }
  }

  return false;
};
